// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.project-view {
  min-height: 100vh;
}

.project-content {
  padding: 20px;
  max-width: 1200px;
  margin: 0 auto;
}

/* Header */
.project-header {
  margin-bottom: 30px;
}

.back-button {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: #666;
  text-decoration: none;
  margin-bottom: 20px;
  font-weight: 500;
  transition: color 0.3s;
}

.back-button:hover {
  color: var(--main-text-color-highligth);
}

.project-title-section {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}

.project-title-section h1 {
  margin: 0;
  font-size: 2.5rem;
  color: #333;
}

.status-badge {
  color: white;
  padding: 8px 16px;
  border-radius: 24px;
  font-size: 14px;
  font-weight: 500;
  text-transform: uppercase;
}

/* Tabs */
.tabs-navigation {
  display: flex;
  border-bottom: 2px solid #f0f0f0;
  margin-bottom: 30px;
  gap: 4px;
}

.tab-button {
  padding: 12px 24px;
  background: none;
  border: none;
  font-size: 16px;
  font-weight: 500;
  color: #666;
  cursor: pointer;
  border-bottom: 3px solid transparent;
  transition: all 0.3s;
  white-space: nowrap;
}

.tab-button:hover {
  color: var(--main-text-color-highligth);
  background-color: rgba(74, 124, 89, 0.05);
}

.tab-button.active {
  color: var(--main-text-color-highligth);
  border-bottom-color: var(--main-text-color-highligth);
}

.tab-content {
  min-height: 400px;
}

/* Overview Tab */
.overview-tab {
  space-y: 30px;
}

.project-details-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 30px;
  margin-bottom: 40px;
}

.project-image-section {
  display: flex;
  justify-content: center;
  align-items: center;
}

.project-main-image {
  width: 100%;
  max-width: 400px;
  height: 300px;
  object-fit: cover;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.placeholder-main-image {
  width: 100%;
  max-width: 400px;
  height: 300px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.placeholder-main-image span {
  color: white;
  font-size: 4rem;
  font-weight: 700;
}

.info-card {
  background: white;
  padding: 24px;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.info-card h3 {
  margin: 0 0 20px 0;
  color: #333;
  font-size: 1.3rem;
}

.info-grid {
  display: grid;
  gap: 16px;
}

.info-item {
  display: grid;
  grid-template-columns: 120px 1fr;
  gap: 12px;
  align-items: start;
}

.info-item label {
  font-weight: 600;
  color: #555;
  font-size: 14px;
}

.info-item span {
  color: #333;
  word-break: break-word;
}

/* Stats Grid */
.project-stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
  margin-top: 40px;
}

.stat-card {
  background: white;
  padding: 24px;
  border-radius: 12px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  text-align: center;
  transition: transform 0.3s;
}

.stat-card:hover {
  transform: translateY(-4px);
}

.stat-card h3 {
  font-size: 2rem;
  margin: 0 0 8px 0;
  color: var(--main-text-color-highligth);
  font-weight: 700;
}

.stat-card p {
  color: #666;
  margin: 0;
  font-size: 14px;
}

/* Tab Content Areas */
.damages-tab,
.work-reports-tab {
  background: white;
  border-radius: 16px;
  padding: 24px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.loading {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
  font-size: 1.2rem;
  color: #666;
}

.project-not-found {
  text-align: center;
  padding: 60px 20px;
  color: #666;
  font-size: 1.2rem;
}

/* Mobile Responsive */
@media (max-width: 768px) {
  .project-view {
    padding: 15px;
  }
  
  .project-title-section {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
  
  .project-title-section h1 {
    font-size: 2rem;
  }
  
  .tabs-navigation {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    -ms-overflow-style: none;
  }
  
  .tabs-navigation::-webkit-scrollbar {
    display: none;
  }
  
  .project-details-grid {
    grid-template-columns: 1fr;
    gap: 20px;
  }
  
  .project-stats-grid {
    grid-template-columns: repeat(2, 1fr);
  }
  
  .info-item {
    grid-template-columns: 1fr;
    gap: 4px;
  }
  
  .info-item label {
    font-weight: 600;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/project/ProjectView.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA,WAAW;AACX;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,WAAW;EACX,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA,SAAS;AACT;EACE,aAAa;EACb,gCAAgC;EAChC,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,oCAAoC;EACpC,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA;EACE,uCAAuC;EACvC,yCAAyC;AAC3C;;AAEA;EACE,uCAAuC;EACvC,qDAAqD;AACvD;;AAEA;EACE,iBAAiB;AACnB;;AAEA,iBAAiB;AACjB;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,6DAA6D;EAC7D,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,sBAAsB;AACxB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,yCAAyC;EACzC,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,eAAe;AACjB;;AAEA,sBAAsB;AACtB;;EAEE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,iCAAiC;IACjC,qBAAqB;IACrB,wBAAwB;EAC1B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,qCAAqC;EACvC;;EAEA;IACE,0BAA0B;IAC1B,QAAQ;EACV;;EAEA;IACE,gBAAgB;EAClB;AACF","sourcesContent":[".project-view {\r\n  min-height: 100vh;\r\n}\r\n\r\n.project-content {\r\n  padding: 20px;\r\n  max-width: 1200px;\r\n  margin: 0 auto;\r\n}\r\n\r\n/* Header */\r\n.project-header {\r\n  margin-bottom: 30px;\r\n}\r\n\r\n.back-button {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  color: #666;\r\n  text-decoration: none;\r\n  margin-bottom: 20px;\r\n  font-weight: 500;\r\n  transition: color 0.3s;\r\n}\r\n\r\n.back-button:hover {\r\n  color: var(--main-text-color-highligth);\r\n}\r\n\r\n.project-title-section {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 16px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.project-title-section h1 {\r\n  margin: 0;\r\n  font-size: 2.5rem;\r\n  color: #333;\r\n}\r\n\r\n.status-badge {\r\n  color: white;\r\n  padding: 8px 16px;\r\n  border-radius: 24px;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  text-transform: uppercase;\r\n}\r\n\r\n/* Tabs */\r\n.tabs-navigation {\r\n  display: flex;\r\n  border-bottom: 2px solid #f0f0f0;\r\n  margin-bottom: 30px;\r\n  gap: 4px;\r\n}\r\n\r\n.tab-button {\r\n  padding: 12px 24px;\r\n  background: none;\r\n  border: none;\r\n  font-size: 16px;\r\n  font-weight: 500;\r\n  color: #666;\r\n  cursor: pointer;\r\n  border-bottom: 3px solid transparent;\r\n  transition: all 0.3s;\r\n  white-space: nowrap;\r\n}\r\n\r\n.tab-button:hover {\r\n  color: var(--main-text-color-highligth);\r\n  background-color: rgba(74, 124, 89, 0.05);\r\n}\r\n\r\n.tab-button.active {\r\n  color: var(--main-text-color-highligth);\r\n  border-bottom-color: var(--main-text-color-highligth);\r\n}\r\n\r\n.tab-content {\r\n  min-height: 400px;\r\n}\r\n\r\n/* Overview Tab */\r\n.overview-tab {\r\n  space-y: 30px;\r\n}\r\n\r\n.project-details-grid {\r\n  display: grid;\r\n  grid-template-columns: 1fr 1fr;\r\n  gap: 30px;\r\n  margin-bottom: 40px;\r\n}\r\n\r\n.project-image-section {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.project-main-image {\r\n  width: 100%;\r\n  max-width: 400px;\r\n  height: 300px;\r\n  object-fit: cover;\r\n  border-radius: 16px;\r\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.placeholder-main-image {\r\n  width: 100%;\r\n  max-width: 400px;\r\n  height: 300px;\r\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border-radius: 16px;\r\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.placeholder-main-image span {\r\n  color: white;\r\n  font-size: 4rem;\r\n  font-weight: 700;\r\n}\r\n\r\n.info-card {\r\n  background: white;\r\n  padding: 24px;\r\n  border-radius: 16px;\r\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.info-card h3 {\r\n  margin: 0 0 20px 0;\r\n  color: #333;\r\n  font-size: 1.3rem;\r\n}\r\n\r\n.info-grid {\r\n  display: grid;\r\n  gap: 16px;\r\n}\r\n\r\n.info-item {\r\n  display: grid;\r\n  grid-template-columns: 120px 1fr;\r\n  gap: 12px;\r\n  align-items: start;\r\n}\r\n\r\n.info-item label {\r\n  font-weight: 600;\r\n  color: #555;\r\n  font-size: 14px;\r\n}\r\n\r\n.info-item span {\r\n  color: #333;\r\n  word-break: break-word;\r\n}\r\n\r\n/* Stats Grid */\r\n.project-stats-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\r\n  gap: 20px;\r\n  margin-top: 40px;\r\n}\r\n\r\n.stat-card {\r\n  background: white;\r\n  padding: 24px;\r\n  border-radius: 12px;\r\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\r\n  text-align: center;\r\n  transition: transform 0.3s;\r\n}\r\n\r\n.stat-card:hover {\r\n  transform: translateY(-4px);\r\n}\r\n\r\n.stat-card h3 {\r\n  font-size: 2rem;\r\n  margin: 0 0 8px 0;\r\n  color: var(--main-text-color-highligth);\r\n  font-weight: 700;\r\n}\r\n\r\n.stat-card p {\r\n  color: #666;\r\n  margin: 0;\r\n  font-size: 14px;\r\n}\r\n\r\n/* Tab Content Areas */\r\n.damages-tab,\r\n.work-reports-tab {\r\n  background: white;\r\n  border-radius: 16px;\r\n  padding: 24px;\r\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.loading {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  height: 200px;\r\n  font-size: 1.2rem;\r\n  color: #666;\r\n}\r\n\r\n.project-not-found {\r\n  text-align: center;\r\n  padding: 60px 20px;\r\n  color: #666;\r\n  font-size: 1.2rem;\r\n}\r\n\r\n/* Mobile Responsive */\r\n@media (max-width: 768px) {\r\n  .project-view {\r\n    padding: 15px;\r\n  }\r\n  \r\n  .project-title-section {\r\n    flex-direction: column;\r\n    align-items: flex-start;\r\n    gap: 12px;\r\n  }\r\n  \r\n  .project-title-section h1 {\r\n    font-size: 2rem;\r\n  }\r\n  \r\n  .tabs-navigation {\r\n    overflow-x: auto;\r\n    -webkit-overflow-scrolling: touch;\r\n    scrollbar-width: none;\r\n    -ms-overflow-style: none;\r\n  }\r\n  \r\n  .tabs-navigation::-webkit-scrollbar {\r\n    display: none;\r\n  }\r\n  \r\n  .project-details-grid {\r\n    grid-template-columns: 1fr;\r\n    gap: 20px;\r\n  }\r\n  \r\n  .project-stats-grid {\r\n    grid-template-columns: repeat(2, 1fr);\r\n  }\r\n  \r\n  .info-item {\r\n    grid-template-columns: 1fr;\r\n    gap: 4px;\r\n  }\r\n  \r\n  .info-item label {\r\n    font-weight: 600;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
